import { service } from '../axios';
export function getLabHomeList() {
    return service({
        url: '/labWeb/getLabHomeList',
        method: 'get'
    });
}
export function getLabDetail(labId) {
    return service({
        url: '/labWeb/getLabDetail',
        method: 'get',
        params: { labId } // 注意这里是 params，GET 请求 query 参数
    });
}
export function verifyLabCertificate(verifyCode, labId) {
    return service({
        url: '/labWeb/verifyCertificate',
        method: 'get',
        params: { verifyCode, labId } // 注意这里是 params，GET 请求 query 参数
    });
}
